import { defineComponent, computed, getCurrentInstance } from "vue";
export default defineComponent({
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var showBalanceAlert = computed(function() {
            return store.getters.isInsufficientBalance;
        });
        var balanceThreshold = computed(function() {
            return store.state.user.info.min_amount >= 0 ? store.state.user.info.min_amount + 100 : 100;
        });
        return {
            showBalanceAlert: showBalanceAlert,
            balanceThreshold: balanceThreshold
        };
    }
});
